import { useContext } from 'react'
import { contextoSesion, type ContextoSesion } from './SesionProvider'

export function useSesion(): ContextoSesion {
  const valor = useContext(contextoSesion)
  if (!valor) throw new Error('useSesion debe usarse dentro de SesionProvider')
  return valor
}
